import store from '@/store'
import request from '@/api/axioRequest.js'
import _ from 'lodash'

export default {
  saveReportSuites (data) {
    return request.post('adobe_connections/savereportsuite/', data)
  },
  getAAConnection () {
    return request.get('adobe_connections/get/')
      .then(response => {
        response.forEach(resp => {
          resp.type = 'adobe'
          resp.company_name = resp.name
        })
        store.commit('data/updateAA', response)
        return response
      })
  },
  saveAAConnection (data) {
    return request.post('adobe/connections/save/', data)
  },
  DeleteAAConnection (data) {
    return request.post('adobe_connections/delete/', data)
  },
  getReportSuites (id) {
    return request.get(`adobe/getreportsuites/?adobe_connection_id=${id}`)
  },
  getevars (id) {
    return request.get(`adobe/getevars/?adobe_connection_id=${id}`)
      .then(response => {
        if (response.error) {
          return response
        }
        response = _.sortBy(response, [function (a) { return a.name }])
        return response
      })
  },
  getEvents (id) {
    return request.get(`adobe/getevents/?adobe_connection_id=${id}`)
      .then(response => {
        if (response.error) {
          return response
        }
        response = _.sortBy(response, [function (a) { return a.name }])
        return response
      })
  },
  analyticsImportLogs () {
    return request.get('logs/get/')
  },
  getFtp (id) {
    return request.get('ftp/get/?adobe_connection_id=' + id)
  },
  saveFtp (data) {
    return request.post('ftp/save/', data)
  },
  checkFtp (data) {
    return request.post('ftp/check/', data)
  }
}
